export default {
  base: {
    funKey: 'base',
    name: '基础',
    apis: [{
      path: '/basis/worker',
      method: 'GET'
    },
    {
      path: '/basis/status_manage/config',
      method: 'GET'
    },
    {
      path: '/basis/official_document_send',
      method: 'GET'
    },
    {
      path: '/basis/official_document_send/by_auth',
      method: 'GET'
    },
    {
      path: '/basis/official_document_send/{id}',
      method: 'DELETE'
    },
    {
      path: '/basis/official_document_send/{id}',
      method: 'PUT'
    },
    {
      path: '/basis/official_document_send/switch/{id}',
      method: 'POST'
    }]
  },
  add: {
    funKey: 'add',
    name: '新增申请',
    apis: [{
      path: '/basis/official_document_send',
      method: 'POST'
    }]
  },
  getDataFile: {
    funKey: 'getDataFile',
    name: '获取扫描件'
  },
  updateDataFile: {
    funKey: 'updateDataFile',
    name: '上传扫描件',
    apis: [{
      path: '/basis/official_document_send/file_ids/{id}',
      method: 'PUT'
    }]
  },
  delDataFile: {
    funKey: 'delDataFile',
    name: '删除扫描件',
    apis: [{
      path: '/basis/official_document_send/file_ids/{id}',
      method: 'PUT'
    }]
  }
}